import { menuTabSet } from "@/app/utils/constant/menuTabSet"

export class RaceNo extends Number {
  constructor(value?:string | number){
    if (!value) {
      super(0)
      return
    }
    switch (typeof value) {
      case 'string':
        super(value?.toUpperCase() === "ALL" ? -1 : value.split('_')[value.split('_').length-1]?.replace(/[^0-9]/g, ''))
        return
      default:
        super(value)
        return
    }
  }
  toParams(){
    return this.valueOf() ? (this.valueOf() === -1 ? "ALL" : this.toString()) : ''
  }
  isEqual(displayName?: string){
    return new RaceNo(displayName).valueOf() === this.valueOf()
  }
  isEmpty(){
    return this.valueOf() === 0 || this.valueOf() === null || this.valueOf() === undefined
  }
  isExistedInCMS(mtgRaces: IRace[]){
    const selectedRaceIdx = mtgRaces ? mtgRaces?.findIndex((r: IRace)=>this.isEqual(r.displayName)) : -1;
    console.log('race no validation', this.toParams(), 'found in sitecore?', selectedRaceIdx !== -1); 
    return selectedRaceIdx !== -1;
  }
  isValid(menuTab: MenuTab){
    return (!this.isEmpty() && this.valueOf() !== -1) || this.isAllRace(menuTab);
  }
  isAllRace(menuTab: MenuTab){
    return this.valueOf() === -1 && menuTabSet.RESULTS === menuTab.toString();
  }
}

export class MenuTab extends String {
  constructor(value:string){
    super(value?.toLowerCase()?.replace(/[^A-Z0-9]/ig, "-"));
  }  
  toString(){
    return decodeURIComponent(this.valueOf()).toLowerCase().replace(/[^A-Z0-9]/ig, " ")
  }
  isEqual(displayName?: string){
    return displayName ? this.toString() === new MenuTab(displayName).toString() : false
  }
  isValid(){
    return Object.values(menuTabSet).includes(this.toString())
  }
}